import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import cn from 'classnames'
import { isForwarding } from 'util/draft'
import { getValueByPath } from 'util/objects'

import ToRow from '../ToRow'
import CcRow from '../CcRow'
import BccRow from '../BccRow'
import FromRow from '../FromRow'
import SubjectRow from '../SubjectRow'

const indentedStyle = css`
  margin-left: 40px;
`

const gapStyle = css`
  gap: 6px 0;
`

const Expanded = ({
  bccVisible,
  ccVisible,
  children, // i.e. FormSwitcherButton
  className,
  draft,
  draftId,
  draftType,
  focusField,
  forwarding,
  fromVisible,
  mailboxId,
  onActionClick,
  onMailboxClick,
  onSubjectChange,
  onSubjectEnter,
  recipients,
  recipientsTo,
  recipientsCc,
  recipientsBcc,
  recipientsOpenUpward,
  subjectVisible,
  subject,
  ticketId,
  onToUpdate,
  onCcUpdate,
  onBccUpdate,
}) => {
  const startInEditMode =
    ((isForwarding(draftType) || forwarding) &&
      !getValueByPath('to[0].id', recipients)) ||
    focusField === 'to'

  return (
    <div className={cn('grui flex flex-col', className)} css={gapStyle}>
      <ToRow
        bccVisible={bccVisible}
        ccVisible={ccVisible}
        fromVisible={fromVisible}
        isForwarding={forwarding}
        onActionClick={onActionClick}
        subjectVisible={subjectVisible}
        ticketId={ticketId}
        recipients={recipientsTo || (recipients && recipients.to)}
        recipientsOpenUpward={recipientsOpenUpward}
        startInEditMode={startInEditMode}
        key={ticketId}
        onUpdate={onToUpdate}
      >
        {children}
      </ToRow>

      {ccVisible && (
        <div css={children && indentedStyle}>
          <CcRow
            recipients={recipientsCc || (recipients && recipients.cc)}
            startInEditMode={focusField === 'cc'}
            ticketId={ticketId}
            recipientsOpenUpward={recipientsOpenUpward}
            onUpdate={onCcUpdate}
          />
        </div>
      )}

      {bccVisible && (
        <div css={children && indentedStyle}>
          <BccRow
            recipients={recipientsBcc || (recipients && recipients.bcc)}
            startInEditMode={focusField === 'bcc'}
            ticketId={ticketId}
            recipientsOpenUpward={recipientsOpenUpward}
            onUpdate={onBccUpdate}
          />
        </div>
      )}

      {fromVisible && (
        <div css={children && indentedStyle}>
          <FromRow
            draft={draft}
            mailboxId={mailboxId}
            onMailboxClick={onMailboxClick}
          />
        </div>
      )}

      {subjectVisible && (
        <div css={children && indentedStyle}>
          <SubjectRow
            draft={draft}
            draftId={draftId}
            ticketId={ticketId}
            subject={subject}
            onChange={onSubjectChange}
            onEnter={onSubjectEnter}
            startInEditMode={focusField === 'subject'}
          />
        </div>
      )}
    </div>
  )
}

Expanded.propTypes = {
  draft: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  recipientsOpenUpward: PropTypes.bool,
}

Expanded.defaultProps = {
  draft: null,
  recipientsOpenUpward: false,
}

export default styled(Expanded)`
  width: 100%;
`
